<script>
	import Header from '../components/Header.svelte';
	import Results from '../components/Results.svelte';

	export let pathElements = [];
</script>

<Header />
<Results />
